import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { CalendarOutlineIcon } from '../../icons/inputIcons';

const DatePickerPopperZIndex = createGlobalStyle`
    .ui-datepicker-popper {
        z-index: 100;
    }
`;

interface Props {
    children: React.ReactNode;
    className?: string;
    width?: string;
    mobileWidth?: string;
}

const DatePickerShell: React.FC<Props> = ({
    children,
    className,
    width = '14rem',
    mobileWidth = '11rem',
}) => (
    <>
        <DatePickerPopperZIndex />
        <Shell className={className} $width={width} $mobileWidth={mobileWidth}>
            <CalendarSlot aria-hidden>
                <CalendarOutlineIcon />
            </CalendarSlot>
            {children}
        </Shell>
    </>
);

export default DatePickerShell;

const Shell = styled.div<{ $width: string; $mobileWidth: string }>`
    flex-shrink: 0;
    position: relative;
    box-sizing: border-box;
    width: ${({ $width }) => $width};
    height: 2.875rem;
    background: ${({ theme }) => theme.colors.surface};
    border: 1px solid ${({ theme }) => theme.colors.inputBorder};
    border-radius: 0.875rem;
    direction: rtl;
    display: flex;
    align-items: center;
    transition:
        border-color ${({ theme }) => theme.motion.fast} ease,
        box-shadow ${({ theme }) => theme.motion.fast} ease;

    &:hover {
        border-color: ${({ theme }) => theme.colors.inputBorderHover};
    }
    &:focus-within {
        border-color: ${({ theme }) => theme.colors.ink};
        box-shadow: ${({ theme }) => theme.shadows.focus};
    }

    .react-datepicker-wrapper,
    .react-datepicker__input-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }

    .datePicker {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        background: transparent;
        border: 0;
        margin: 0;
        padding: 0 1rem;
        padding-inline-start: 2.25rem;
        color: ${({ theme }) => theme.colors.ink};
        font-family: ${({ theme }) => theme.fonts.sans};
        font-size: ${({ theme }) => theme.text.lg};
        line-height: 1.2;
        text-align: right;
        direction: rtl;
        outline: none;
        border-radius: 0.875rem;

        &::placeholder {
            color: ${({ theme }) => theme.colors.ink4};
        }

        @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
            font-size: ${({ theme }) => theme.textMobile.lg};
            padding: 0 0.75rem;
            padding-inline-start: 2rem;
        }
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 2.5rem;
        width: ${({ $mobileWidth }) => $mobileWidth};
    }
`;

const CalendarSlot = styled.span`
    position: absolute;
    inset-inline-start: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    color: ${({ theme }) => theme.colors.icon};
    display: grid;
    place-items: center;
    pointer-events: none;
    z-index: 1;

    svg {
        width: 1.05rem;
        height: 1.05rem;
    }
`;
